import { Component, OnInit, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { Rule, RuleInterface } from '@vendasta/automata';
import { UntypedFormArray, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { CommonTriggerPanelComponent } from '../../../common/common-trigger-panel.component';
import { WORKFLOW_TRIGGERS } from '../../../../component-loader/trigger-definitions';
import { CrmEmailActivitySelectorComponent } from '../selector/crm-email-activity-selector.component';

@Component({
  selector: 'automata-crm-email-activity-created-modified-panel',
  imports: [CommonModule, TranslateModule, CrmEmailActivitySelectorComponent],
  templateUrl: './crm-email-activity-created-modified-panel.component.html',
  styleUrls: ['./crm-email-activity-created-modified-panel.component.scss'],
})
export class CrmEmailActivityCreatedModifiedPanelComponent extends CommonTriggerPanelComponent implements OnInit {
  description = '';
  @ViewChild(CrmEmailActivitySelectorComponent, { static: true })
  emailActivitySelector!: CrmEmailActivitySelectorComponent;

  constructor() {
    super();
  }

  ngOnInit() {
    super.ngOnInit();

    this.description = WORKFLOW_TRIGGERS?.[this.taskDefinitionId]?.name;
    const triggerRules = this.triggerChoices?.rules;
    if (triggerRules?.length) {
      this.emailActivitySelector.setByRule(Rule.fromRuleInterface(triggerRules[0]));
    }

    this.savingEnabled$.next(true);
  }

  fillRuleValues(_: RuleInterface[]): RuleInterface[] {
    return [this.emailActivitySelector.getRule().toRuleInterface()];
  }

  getBaseRules(): RuleInterface[] {
    return [this.emailActivitySelector.getRule().toRuleInterface()];
  }

  getControlsToValidateOnSave(): (UntypedFormControl | UntypedFormGroup | UntypedFormArray)[] {
    return [this.emailActivitySelector];
  }

  isFormValid(): boolean {
    return this.emailActivitySelector.valid;
  }
}
